/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import LecturerListItem from './LecturerListItem'
import {InfiniteScroll} from '../../components'

class LecturerListHistory extends React.Component {

    constructor() {
        super();
        this.state = {
            loading: false
        }
    }


    handelLoadMore() {
        this.setState({
            loading: true
        });
        const {urlData} = this.props;
        axios.get(`/api/lecture/${urlData.target_id}/lecturer/list`,{
            params: {
                offset: this.props.current.next_offset
            }
        })
            .then(res => {
                if (res.data.code === 0){
                    this.setState({
                        loading: false
                    });
                    let oldlist = this.props.currentList;
                    let list = oldlist.concat(res.data.data.not_imported_lecturers)
                    let selectedList = list.filter((item) => {
                        return item.is_imported === true
                    });
                    this.props.dispatch({
                        type: 'LECTURER_INVITE_INIT',
                        payload: res.data.data
                    });
                    this.props.dispatch({
                        type: 'LECTURER_INVITE_APPEND',
                        payload: list
                    });
                    this.props.dispatch({
                        type: 'LECTURER_SELECTED_LIST',
                        payload: selectedList
                    })
                }
            })
    }

    render() {
        const {currentList, current} = this.props;
        return (
            <div className="lecturer-invite-list">
                {currentList && currentList.length > 0 &&
                <div>
                    <InfiniteScroll onTouchBottom={() => this.handelLoadMore()}
                                    isStop={this.state.loading}
                                    distance={300}
                                    isKill={!current.has_more}/>
                    {currentList.map((item, index) => <LecturerListItem type={'history'} key={index} content={item} />)}
                </div>
                }
            </div>
        )
    }
}

export default connect(state => ({
    current: state.lecturerInvite.current,
    currentList: state.lecturerInvite.currentList,
    urlData: state.lecturerInvite.urlData
}))(LecturerListHistory)



// WEBPACK FOOTER //
// ./src/components/lecturerInvite/LecturerListHistory.js